import { parseMarkdownBlock } from "./parseMarkdownBlock";

export type MarkdownBlock =
  | {
      type: "text";
      content: MarkdownSpan[];
    }
  | {
      type: "header";
      level: 1 | 2 | 3 | 4 | 5 | 6;
      content: MarkdownSpan[];
    }
  | {
      type: "list";
      items: MarkdownSpan[][];
    }
  | {
      type: "numbered-list";
      items: { number: number; spans: MarkdownSpan[] }[];
    }
  | {
      type: "code-block";
      language: string | null;
      content: string;
    }
  | {
      type: "mermaid";
      content: string;
    }
  | {
      type: "horizontal-rule";
    }
  | {
      type: "options";
      items: string[];
    }
  | {
      type: "table";
      headers: string[];
      rows: string[][];
    };

export type MarkdownSpan = {
  styles: Array<"italic" | "bold" | "semibold" | "code">;
  text: string;
  url: string | null;
};

export function parseMarkdown(markdown: string): MarkdownBlock[] {
  return parseMarkdownBlock(markdown);
}
